import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/fleet", label: "The Fleet" },
];

export const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-2xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-1">
          <span className="font-serif text-2xl tracking-tight">A+Auto</span>
          <span className="text-[#D4AF37] font-serif text-2xl">Fleet</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide transition-colors ${
                location.pathname === l.to ? "text-white" : "text-white/50 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-reserve-btn"
            onClick={() => navigate("/fleet")}
            className="bg-white text-black text-sm px-6 py-2.5 hover:bg-[#D4AF37] transition-colors"
          >
            Reserve Now
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/90 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-white/70 hover:text-white text-lg"
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="mobile-reserve-btn"
            onClick={() => { setOpen(false); navigate("/fleet"); }}
            className="bg-white text-black py-3 mt-2"
          >
            Reserve Now
          </button>
        </div>
      )}
    </header>
  );
};
